import React, {Fragment} from "react";
import imageKozijn from '../../../images/situation/maten/kozijn/M.jpg';
import imageMuur from '../../../images/situation/maten/muur/M.jpg';
import PropTypes from "prop-types";

export default function MaatM(props) {
    return <Fragment>
        <div className="addtextMore">
            Hier kunt u de maat van voorkant kozijn tot voorkant muur invullen.<br/>
            <br/>
            Deze maat wordt ook wel de neggemaat genoemd.
        </div>
        <img className="explainImage" src={props.isMuurMontage ? imageMuur : imageKozijn} alt=""/>
    </Fragment>;
}

MaatM.propTypes = {
    isMuurMontage: PropTypes.bool.isRequired
}